(() => {
  const rootSelector = '[data-aiga-resources-article]';

  const slugify = (value) =>
    value
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'section';

  const initialize = (root) => {
    if (root.dataset.aigaTocReady === 'true') return;

    const content = root.querySelector('[data-aiga-article-content]');
    const tocTargets = root.querySelectorAll('[data-aiga-toc]');
    if (!content || tocTargets.length === 0) return;

    const usedIds = new Set(
      Array.from(document.querySelectorAll('[id]'))
        .map((element) => element.id)
        .filter(Boolean),
    );
    const headings = Array.from(content.querySelectorAll('h2'));

    headings.forEach((heading, index) => {
      if (heading.id) return;

      const baseId = slugify(heading.textContent || `section-${index + 1}`);
      let candidate = baseId;
      let suffix = 2;
      while (usedIds.has(candidate)) {
        candidate = `${baseId}-${suffix}`;
        suffix += 1;
      }
      heading.id = candidate;
      usedIds.add(candidate);
    });

    if (headings.length < 2) {
      root.dataset.aigaTocReady = 'true';
      return;
    }

    tocTargets.forEach((target) => {
      const list = target.querySelector('ol');
      if (!list) return;

      const fragment = document.createDocumentFragment();
      headings.forEach((heading) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        fragment.append(item);
      });
      list.replaceChildren(fragment);
      target.hidden = false;
    });

    root.dataset.aigaTocReady = 'true';
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
